const SMILES = {
  ':)': [/:\)/g, 'face-smile.gif'],
  ':(': [/:\(/g, 'face-sad.gif'],
}

export default function filterCommentFilter(textUnknown: string) {
  let text = textUnknown

  Object.entries(SMILES).forEach(([smile, [smilePattern, fileName]]) => {
    text = text.replace(smilePattern, `<img src="/static/_v1/pd/icons/emoji/${fileName}" alt="${smile}">`)
  })

  return text
}
